import { render, staticRenderFns } from "./KinvaDocList.vue?vue&type=template&id=1ff5a34c"
import script from "./KinvaDocList.vue?vue&type=script&lang=js"
export * from "./KinvaDocList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports